module.exports = __webpack_public_path__ + "static/media/gitlarge.55ac187e.png";